import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Title, Amount } from '../shared/styled';

interface BalanceDisplayProps {
    balance: number;
}

export const BalanceDisplay: React.FC<BalanceDisplayProps> = ({ balance }) => {
    return (
        <Container>
            <Title>
                <FormattedMessage
                    id="Finance.Balance.Label"
                    defaultMessage="USD Balance"
                />
            </Title>
            <Amount>$ {balance.toFixed(2)}</Amount>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 280px;

    @media (max-width: 1024px) {
        order: -1;
        min-width: auto;
    }

    @media (max-width: 768px) {
        border-radius: 20px 20px 0 0;
    }
`;
